module.exports = __webpack_public_path__ + "img/app-food.2405424c.png";